import { useEmployeeIsNursingHomeAdminOrManager } from '@pflegenavi/frontend/nursing-home-context';

import { useEmployeeProfilePhoenix } from '@pflegenavi/frontend/api-nursing-home';

export function useCanSeeEmployeeList(): boolean {
  const { data: employeeProfile } = useEmployeeProfilePhoenix({});

  const isNursingHomeAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  // The employee list requires the new authorization system (roles), so we gate
  // it on `use_new_authorization` instead of the former EmployeeManagement
  // feature flag — hidden on legacy-authorization tenants.
  return (
    Boolean(employeeProfile?.use_new_authorization) &&
    isNursingHomeAdminOrManager
  );
}
